export default function Tindakan() {
    return {
        id: null,
        nama: null,
        latest: false,
        parent: null
    };
}
